<template>
  <div>

    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Unit</li>
              </ol>
            </div>
            <h4 class="page-title">Unit</h4>
          </div>
        </div>
      </div>

      <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>
       
      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <router-link :to="{ name: 'instanceUnitCreate' }" class="btn btn-success waves-effect waves-light left-action"
                v-if="$store.state.permission.includes('company-unit.store')">Tambah Unit</router-link>
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Nama Unit</th>
                                <th>Lokasi Unit</th>
                                <th>Custom Jabatan 1</th>
                                <th>Nama Pejabat</th>
                                <th>Golongan Pejabat</th>
                                <th>NIP</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in data" :key="item.id">
                                <td>{{item.name}}</td>
                                <td>{{item.location}}</td>
                                <td>{{item.position_1_name}}</td>
                                <td>{{item.placeman_name}}</td>
                                <td>{{item.placeman_position}}</td>
                                <td>{{item.nip}}</td>
                                <td>
                                    <router-link class="btn btn-primary waves-effect waves-light"
                                        v-if="$store.state.permission.includes('company-unit.update')"
                                        :to="{ name: 'instanceUnitEdit', params: { id: item.id } }"
                                        >
                                        <i class="fas fa-pen"></i>
                                    </router-link>
                                    <button class="btn btn-danger waves-effect waves-light ml-2" @click.prevent="deleteItem(item.id)"
                                        v-if="$store.state.permission.includes('company-unit.delete')">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            loading: true,
            data: [],
        }
    },
    methods: {
        loadData() {
            this.loading = true;
            this.$http.get(`${this.API_URL}company/unit`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                if(result.success) {
                    this.data = result.data
                    setTimeout(() => {
                        this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        deleteItem(id){
            Swal.fire({
            title: 'Apakah anda yakin untuk menghapus ?<br> <b>Data ini memiliki relasi dengan data lainnya, pastikan dengan baik!<b>',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                if (result.value) {
                     this.loading = true
                     this.$http.delete(`${this.API_URL}company/unit/delete/${id}`, {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    })
                    .then(() => {
                        this.loadData()
                    })
                    .catch(error => {
                        this.loading = false;
                        this.errorHandler(error)
                    });
                }
            })
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>